import React from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import { AuthPage } from './pages/AuthPage'
import AddClientPage from './pages/AddClientPage'
import { MainPage } from './pages/MainPage'
import { CardsPage } from './pages/CardsPage'
import { BaseSelectionPage } from './pages/BaseSelectionPage'
import EditClientPage from './pages/EditClientPage'
import { SearchPage } from './pages/SearchPage'
import { CostPage } from './pages/CostPage'

export const useRoutes = (isAuthenticated, base) => {
    if (isAuthenticated){
        return(
            <Switch>
                <Route path="/bases" exact>
                    <BaseSelectionPage/>
                </Route>
                <Route path="/main" exact>
                    <MainPage/>
                </Route>
                <Route path="/cards" exact>
                    <CardsPage/>
                </Route>
                <Route path="/add" exact>
                    <AddClientPage/>
                </Route>
                <Route path="/edit" exact>
                    <EditClientPage/>
                </Route>
                <Route path="/search" exact>
                    <SearchPage/>
                </Route>
                <Route path="/costs" exact>
                    <CostPage/>
                </Route>
                <Redirect to={base ? '/main' : '/bases'}/>
            </Switch>
        )
    }

    return(
        <Switch>
            <Route path="/auth" exact>
                <AuthPage/>
            </Route>
            <Redirect to="/auth" />
        </Switch>
    )
}